//=require ../bower_components/jquery/dist/jquery.js
//=require ../bower_components/bootstrap/dist/js/bootstrap.bundle.js

//=require components/dropdownMenus.js
//=require components/stickyFooter.js
//=require pages/front.js